import { derinApiClient } from "./setup";
import { DerinApiResponse, MigrationPreview, MigrationResult } from "./interface";

/** What the backfill would do for this organization. Read-only. */
export const getMigrationPreview = async (
  organizationId: string
): Promise<MigrationPreview> => {
  const response = await derinApiClient().get<DerinApiResponse<MigrationPreview>>(
    `/collection/migration/organization/${organizationId}`
  );
  return response.data.data;
};

/**
 * Runs the backfill. Idempotent: the backend recomputes what is pending, so a repeat
 * call reports everything as skipped instead of duplicating collections.
 */
export const runMigration = async (
  organizationId: string
): Promise<MigrationResult> => {
  const response = await derinApiClient().post<DerinApiResponse<MigrationResult>>(
    `/collection/migration/organization/${organizationId}`
  );
  return response.data.data;
};
